import { useContext } from 'react';
import { NotificationsContext } from '../context/NotificationsContext';

/**
 * Returns `notify(message, severity?)` for raising transient snackbar
 * notifications that render above open dialogs. Safe to call without the
 * provider mounted (falls back to a no-op default context).
 */
export const useNotify = () => useContext(NotificationsContext).notify;
